import { render } from "./StageDisplay.vue?vue&type=template&id=00ea5235"
import script from "./jsfiles/StageDisplayScript.js?vue&type=script&lang=js"
export * from "./jsfiles/StageDisplayScript.js?vue&type=script&lang=js"

import "./StageDisplayStyle.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__